import type { JournalEntry } from '@/db/journal'
import { init, track } from '@plausible-analytics/tracker'
import type { Ref } from 'vue'

export function initPlausible(loggedIn: Ref<boolean>): void {
  // Initialize Plausible analytics if not already initialized (HMR can cause double initialization otherwise)
  if ('plausible' in window) {
    return
  }
  init({
    endpoint: '/v1/api/event',
    domain: 'clarityboss.com',
    formSubmissions: true,
    outboundLinks: true,
    customProperties: () => ({ logged_in: loggedIn.value ? 'true' : 'false' }),
    transformRequest: (payload) => {
      // replace any UUIDs in the URL with `[uuid]` so pages are better grouped
      payload.u = payload.u.replace(
        /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=[/?]|$)/gi,
        '/[uuid]',
      )
      return payload
    },
  })
}

export { track }

export function trackEntryCreated(entry: Pick<JournalEntry, 'type' | 'personId'>, source: string): void {
  track('Entry: Created', { props: { entryType: entry.type, hasPerson: String(!!entry.personId), source } })
}

export function trackEntryEdited(entry: Pick<JournalEntry, 'type' | 'personId'>, source: string): void {
  track('Entry: Edited', { props: { entryType: entry.type, hasPerson: String(!!entry.personId), source } })
}
